import React from 'react'
import { Button } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { Container } from './styles'
import type { SelectAllButtonProps } from './types'

const SelectAllButton: React.FC<SelectAllButtonProps> = ({ onClick, areOptionsSelected }) => {
  const { t } = useFavurTranslation()

  return (
    <Container>
      <Button color="secondary" onClick={onClick} data-testid="select-all-button">
        {t(areOptionsSelected ? 'button.deselectAll' : 'button.selectAll')}
      </Button>
    </Container>
  )
}

export default SelectAllButton
